// extracted by mini-css-extract-plugin
export default {"infoRow":"InfoRow_infoRow__Y-pHI","last":"InfoRow_last__e82Na","label":"InfoRow_label__z8qiu","value":"InfoRow_value__IECZ6"};